import * as React from 'react'

import { Transport } from '@connectrpc/connect'
import { createRoot } from 'react-dom/client'
import { Helmet, HelmetProvider } from 'react-helmet-async'

import { AuthProvider } from '@enechain/auth-js'
import {
  ApiClientProvider,
  AppRouterProvider,
  LibProvider,
  ProtectedTermAgreeGuard,
  TagManager,
} from '@enechain/eposition-ui'

import '~/i18n'
import { initDatadog } from '~/libs/Datadog'
import { LanguageInitProvider } from '~/providers/LanguageInitProvider'
import { router } from '~/routes'

initDatadog()

const container = document.getElementById('root')

if (container != null) {
  createRoot(container).render(
    <React.StrictMode>
      <HelmetProvider>
        <TagManager gtmId={import.meta.env.VITE_GTM_ID} />
        <LibProvider>
          {import.meta.env.MODE === 'development' && (
            <Helmet>
              <title>[local] eClear Portal</title>
              <link href="/favicon_local.svg" rel="icon" type="image/svg+xml" />
            </Helmet>
          )}
          <AuthProvider
            apiUrl={import.meta.env.VITE_ELOGIN_API_URL}
            loginUrl={import.meta.env.VITE_ELOGIN_URL}
            redirectUri={window.location.origin}
          >
            <ApiClientProvider
              baseUrl={import.meta.env.VITE_API_URL}
              frontendBaseHost={import.meta.env.VITE_FRONTEND_BASE_HOST}
            >
              {(transport: Transport): React.ReactNode => (
                <LanguageInitProvider>
                  <ProtectedTermAgreeGuard
                    eCloudUrl={import.meta.env.VITE_ECLOUD_URL}
                  >
                    <AppRouterProvider
                      createRouter={router}
                      transport={transport}
                    />
                  </ProtectedTermAgreeGuard>
                </LanguageInitProvider>
              )}
            </ApiClientProvider>
          </AuthProvider>
        </LibProvider>
      </HelmetProvider>
    </React.StrictMode>,
  )
}
